import { CanActivate,
		 ActivatedRouteSnapshot,
		 RouterStateSnapshot,
		 Router  
} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { GuestAuthenticationService } from './services/guest-authentication.service';

@Injectable()
export class GuestAuthGuard implements CanActivate {
	constructor(private authService: GuestAuthenticationService, 
		        private router: Router) { } 
	canActivate(route: ActivatedRouteSnapshot,
				state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean{

		return this.authService.isAuthenticated()
		.then(
			(authenticated: boolean) => {
				if(!authenticated){				
					return true;
				}else {
					if(localStorage.getItem("userRole") && localStorage.getItem("userRole") == "client") {
						this.router.navigate(['/talent/sector']);
					} else if(localStorage.getItem("userRole") && localStorage.getItem("userRole") == "recruiter") {
						this.router.navigate(['/recruiter/dashboard']);
					} else if(localStorage.getItem("userRole") && localStorage.getItem("userRole") == "admin") {
						this.router.navigate(['/admin/dashboard']);
					} else {
						this.authService.logout();
					}
				}				
			});
	}

}


// WEBPACK FOOTER //
// ./src/app/guest-auth-guard.service.ts